import React, { useState } from "react";
import "../styles/Faq.css";
import { useLanguage } from "../contexts/LanguageContext";

const Faq = () => {
  const { language, text } = useLanguage();
  const isHeb = language === "he";
  const f = text.faq;
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="faq-section" dir={isHeb ? "rtl" : "ltr"}>
      <span className="eyebrow">{f.eyebrow}</span>
      <h2 className="section-title">{f.title}</h2>
      <p className="faq-lede">{f.lede}</p>

      <div className="faq-list">
        {f.items.map((item, i) => {
          const open = i === openIndex;
          return (
            <div key={i} className={`faq-item ${open ? "is-open" : ""}`}>
              <button
                type="button"
                className="faq-q"
                aria-expanded={open}
                onClick={() => setOpenIndex(open ? -1 : i)}
              >
                <span>{item.q}</span>
                <span className="faq-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
                    <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              </button>
              <div className="faq-a-wrap">
                <p className="faq-a">{item.a}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Faq;
